var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12H10.5V13H5.5V12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14H9.5V15H6.5V14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40505 9.07111C4.71305 8.43211 3.99805 7.76161 3.99805 6.00061C3.99805 3.79511 5.79205 2.00061 7.99805 2.00061V1.00061C5.24055 1.00061 2.99805 3.24361 2.99805 6.00061C2.99805 8.20111 3.99755 9.13461 4.72755 9.80911C5.23355 10.2761 5.49805 10.5416 5.49805 11.0006H6.49805C6.49805 10.0811 5.94255 9.56761 5.40505 9.07111Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.593 9.07111C11.285 8.43211 12 7.76161 12 6.00061C12 3.79511 10.206 2.00061 8 2.00061V1.00061C10.7575 1.00061 13 3.24361 13 6.00061C13 8.20111 12.0005 9.13461 11.2705 9.80911C10.7645 10.2761 10.5 10.5416 10.5 11.0006H9.5C9.5 10.0811 10.0555 9.56761 10.593 9.07111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.d28f62c466941d0972b0b3d7e58dfc79.svg";
export { ForwardRef as ReactComponent };